import { strCode } from "../localizations/strCode";

const notificationManagementErrors = {
  INVALID_NOTIFICATION_NAME: strCode.INVALID_NOTIFICATION_NAME_ERROR,
  INVALID_PARAMETER_PROVIDED: strCode.INVALID_PARAMETER_PROVIDED_ERROR,
  NOTIFICATION_NAME_ALREADY_EXISTS: strCode.NOTIFICATION_NAME_ALREADY_EXISTS_ERROR,
  NOTIFICATION_NOT_FOUND: strCode.NOTIFICATION_NOT_FOUND_ERROR,
  INVALID_ADMIN_GROUP: strCode.INVALID_ADMIN_GROUP_ERROR
};

export default notificationManagementErrors;
